export default "__VITE_ASSET__GbQ1jzhT__"